import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { Trash, Plus, Pencil, FilePdf, FileArrowDown, Copy } from "@phosphor-icons/react";

const tableConfig: FinalTableConfig = {
      index: null,
      actions: [
        {
          name: TableAction.CREATE, 
          showLabel: true,
          label: 'create',
          allowed: true,
          show: true,
          action: null,
          icon: <Plus size={20} />,
        },
      ],
      rowActions: [
        {
          name: RowAction.EDIT, 
          label: 'edit',
          icon: <Pencil size={20} />,
          allowed: true,
          show: true,
          action: (element: any) => {
            console.log('edit', element);
          }
        },
        {
          name: 'replicate-delivery-note', 
          label: 'replicate_delivery_note',
          icon: <Copy size={20} />,
          allowed: true,
          show: true,
          data: 'id',
          action: (element: any) => {
            console.log('replicate', element);
          }
        },
        {
          name: 'generate-pdf', 
          label: 'generate-pdf',
          icon: <FilePdf size={20} />,
          allowed: true,
          show: (element: any) => {
            return !element.pdf_generated;
          },
          action: (element: any) => {
            console.log('generate-pdf', element);
          }
        },
        {
          name: 'download-pdf', 
          label: 'download-pdf',
          icon: <FileArrowDown size={20} />,
          allowed: true,
          data: 'pdf.0.url',
          show: (element: any) => {
            return element.pdf_generated;
          },
          action: (element: any) => {
            console.log('download-pdf', element);
          }
        },
        {
          name: RowAction.DELETE, 
          label: 'delete',
          icon: <Trash size={20} />,
          allowed: true,
          show: true,
          action: (element: any) => { 
            console.log('delete', element);
          }              
        }
      ],
      rowConfiguration: {
        class: (element: any) => {
          return null;
        }
      },
      columns: [
        {
          name: 'id',
          label: '#',
          key: 'id',
          type: 'number',
          show: true,
          allowOrder: true,
        },
        {
          name: 'reference',
          label: 'reference',
          key: 'reference',
          type: 'string',
          show: true,
          allowOrder: true,
        },
        {
          name: 'name',
          label: 'name',
          key: 'receiver_account.fiscal_name',
          type: 'string',
          show: true,
          allowOrder: true,
        },
        {
          name: 'surname',
          label: 'surname',
          key: 'receiver_account.fiscal_first_surname',
          type: 'string',
          show: true,
          allowOrder: true,
        },
        {
          name: 'date',
          label: 'date',
          key: 'date',
          type: 'date',
          show: true,
          allowOrder: true,
        },
        {
          name: 'amount_without_vat',
          label: 'amount_without_vat',
          key: 'amount_without_vat',
          type: 'currency',
          currency: 'EUR',
          show: true,
          allowOrder: true,
        },
        {
          name: 'amount_vat',
          label: 'amount_vat',
          key: 'amount_vat',
          type: 'currency',
          currency: 'EUR',
          show: true,
          allowOrder: true,
        },
        {
          name: 'amount_with_vat',
          label: 'amount_with_vat',
          key: 'amount_with_vat',
          type: 'currency',
          currency: 'EUR',
          show: true,
          allowOrder: true,
        },
  
      ],
      pagination: {
        enabled: true,
        back: true
    }
}
const getConfig: any = (functions: any) => {
    const {
      getFunction,
      indexFunction,
      initializeFunction,
      prepareRemoveFunction,
      initializeGeneratePDFFunction,
      downloadPDFFunction,
      replicateDeliveryNoteFunction,
    } = functions;
    tableConfig.actions[0].action = () => initializeFunction();
    tableConfig.index = () => indexFunction();
    tableConfig.rowActions[0].action = (id: any) => getFunction(id);
    tableConfig.rowActions[1].action = (id: any) => replicateDeliveryNoteFunction(id);
    tableConfig.rowActions[2].action = (id: any) => initializeGeneratePDFFunction(id);
    tableConfig.rowActions[3].action = (url: string) => downloadPDFFunction(url);
    tableConfig.rowActions[4].action = (id: any) => prepareRemoveFunction(id);
    return tableConfig;
}
export default getConfig;
